import colors from 'vuetify/lib/util/colors';

// Tema con colores del SII
// Colores estándar de Vuetify: https://vuetifyjs.com/en/customization/theme/#customizing
export default {
	themes: {
		light: {
			primary: '#002c48', // Azul SII
			secondary: colors.blueGrey.darken3,
			warning: '#e6500a', // Naranjo SII
			success: '#00B050', // Verde SII
			siiNaranjo: '#e6500a',
		},
	},
};
